import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PageBreadcrumb } from "@/components/PageBreadcrumb";
import { SiteLayout } from "@/components/SiteLayout";
import { useSite } from "@/hooks/use-site";
import { getPrivacyPolicy } from "@/lib/privacy-policy";

export function PrivacyPage() {
  const { messages, site } = useSite();

  return (
    <SiteLayout>
      <PageBreadcrumb items={[{ label: messages.privacyHeading }]} />
      <section className="mx-auto max-w-3xl px-6 py-20 sm:py-28">
        <p className="text-sm font-medium text-primary">{messages.privacyEyebrow}</p>
        <h1 className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl">
          {messages.privacyHeading}
        </h1>
        <article className="mt-8 text-sm leading-relaxed text-muted-foreground">
          <ReactMarkdown
            components={{
              a: ({ children, ...props }) => (
                <a className="font-medium text-primary hover:underline" {...props}>
                  {children}
                </a>
              ),
              h2: ({ children }) => (
                <h2 className="mt-10 text-xl font-semibold text-foreground">{children}</h2>
              ),
              h3: ({ children }) => (
                <h3 className="mt-6 font-semibold text-foreground">{children}</h3>
              ),
              li: ({ children }) => <li className="my-1">{children}</li>,
              p: ({ children }) => <p className="mt-4">{children}</p>,
              strong: ({ children }) => (
                <strong className="font-semibold text-foreground">{children}</strong>
              ),
              ul: ({ children }) => <ul className="mt-3 list-disc space-y-1 pl-6">{children}</ul>,
            }}
            remarkPlugins={[remarkGfm]}
          >
            {getPrivacyPolicy(site.locale)}
          </ReactMarkdown>
        </article>
      </section>
    </SiteLayout>
  );
}
